import React, { Component } from "react";
import { Link } from "react-router-dom";

// Layout
import Header from "../layout/header/header1";

// Images
import bannerImg from "../../images/banner/banner3.jpg";
import news12_1 from "../../images/news/news12_1.jpg";
import news12_2 from "../../images/news/news12_2.jpg";
import news12_3 from "../../images/news/news12_3.jpg";
import news12_4 from "../../images/news/news12_4.jpg";
import news12_5 from "../../images/news/news12_5.jpg";
import news12_6 from "../../images/news/news12_6.jpg";
import news12_7 from "../../images/news/news12_7.jpg";
import news12_8 from "../../images/news/news12_8.jpg";

import { withTranslation } from "react-i18next";


class news12 extends Component {
    componentDidMount() { }

    componentWillMount() {
        const { t } = this.props;
        document.getElementById("title").innerText = t("News12_Title");
    }

    componentWillUnmount() {
        const { t } = this.props;
        document.getElementById("title").innerText = t("Home_Title");
    }

    render() {
        const { t } = this.props;

        return (
            <>
                <Header />

                <div className="page-content">
                    <div
                        className="page-banner ovbl-dark"
                        style={{ backgroundImage: "url(" + bannerImg + ")" }}
                    >
                        <div className="container">
                            <div className="page-banner-entry">
                                <h1 className="text-white">{t("News12_Title")}</h1>
                            </div>
                        </div>
                    </div>

                    <div className="breadcrumb-row">
                        <div className="container">
                            <ul className="list-inline">
                                <li>
                                    <Link to="/">{t("News12_LinkHome")}</Link>
                                </li>
                                <li>{t("News12_LinkCourses")}</li>
                            </ul>
                        </div>
                    </div>

                    <div className="content-block">
                        <div className="section-area section-sp1">
                            <div className="container">
                                <div className="row d-flex flex-row-reverse">
                                    <div className="col-xl-9 col-lg-8 col-md-12 col-sm-12">
                                        <div className="courses-post">

                                            <h1>{t("News12_Content_H")}</h1>


                                            {/* P1 */}
                                            <p>{t("News12_P1_MD")}</p>


                                            {/* Video 1 */}
                                            <div style={{ textAlign: "center", margin: "11px 0" }}>
                                                <div
                                                    style={{
                                                        position: "relative",
                                                        width: "100%",
                                                        paddingBottom: "56.25%",
                                                        height: 0,
                                                        overflow: "hidden",
                                                    }}
                                                >
                                                    <iframe
                                                        style={{
                                                            position: "absolute",
                                                            top: 0,
                                                            left: 0,
                                                            width: "100%",
                                                            height: "100%",
                                                            border: 0,
                                                        }}
                                                        title={t("News12_VID1_DESC")}
                                                        src="https://youtube.com/embed/5-W_PCLGrqg?si=hU05en8RmgHiFFre"
                                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                                        allowFullScreen
                                                    ></iframe>
                                                </div>
                                                <div style={{ marginTop: "10px", fontStyle: "italic", color: "#555" }}>
                                                    {t("News12_VID1_DESC")}
                                                </div>
                                            </div>

                                            {/* P2 */}
                                            <p>{t("News12_P2_MD")}</p>


                                            {/* IMG 1 & IMG 2*/}
                                            <div style={{ textAlign: "center", margin: "11px 0" }}>
                                                <div style={{ display: "flex", justifyContent: "center", gap: 0, flexWrap: "wrap" }}>
                                                    <img
                                                        src={news12_1}
                                                        alt={t("News12_IMG2_DESC")}
                                                        style={{ maxWidth: "50%", height: "auto" }}
                                                    />
                                                    <img
                                                        src={news12_2}
                                                        alt={t("News12_IMG3_DESC")}
                                                        style={{ maxWidth: "50%", height: "auto" }}

                                                    />
                                                </div>

                                                <div style={{ marginTop: "10px", fontStyle: "italic", color: "#555" }}>
                                                    {t("News12_IMG3_DESC")}
                                                </div>
                                            </div>



                                            {/* P4 */}
                                            <p>{t("News12_P4_MD")}</p>

                                            {/* Video 2 */}
                                            <div style={{ textAlign: "center", margin: "11px 0" }}>
                                                <div
                                                    style={{
                                                        position: "relative",
                                                        width: "100%",
                                                        paddingBottom: "56.25%",
                                                        height: 0,
                                                        overflow: "hidden",
                                                    }}
                                                >
                                                    <iframe
                                                        style={{
                                                            position: "absolute",
                                                            top: 0,
                                                            left: 0,
                                                            width: "100%",
                                                            height: "100%",
                                                            border: 0,
                                                        }}
                                                        title={t("News12_VID2_DESC")}
                                                        src="https://youtube.com/embed/pB0T2g2mMiE?si=M1l0DaZ9z0Bd5I20"
                                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                                        allowFullScreen
                                                    ></iframe>
                                                </div>
                                                <div style={{ marginTop: "10px", fontStyle: "italic", color: "#555" }}>
                                                    {t("News12_VID2_DESC")}
                                                </div>
                                            </div>

                                            {/* P5 */}
                                            <p>{t("News12_P5_MD")}</p>

                                            {/* P6 */}
                                            <h3>{t("News12_P6_MD_1")}</h3>
                                            <p>{t("News12_P6_MD_2")}</p>
                                            <p>{t("News12_P6_MD_3")}</p>
                                            <p>{t("News12_P6_MD_4")}</p>

                                            {/* Video 3 */}
                                            <div style={{ textAlign: "center", margin: "11px 0" }}>
                                                <div
                                                    style={{
                                                        position: "relative",
                                                        width: "100%",
                                                        paddingBottom: "56.25%",
                                                        height: 0,
                                                        overflow: "hidden",
                                                    }}
                                                >
                                                    <iframe
                                                        style={{
                                                            position: "absolute",
                                                            top: 0,
                                                            left: 0,
                                                            width: "100%",
                                                            height: "100%",
                                                            border: 0,
                                                        }}
                                                        title={t("News12_VID3_DESC")}
                                                        src="https://youtube.com/embed/kkYt_jU0qZQ?si=8VLjYfn6AkCxHPOH"
                                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                                        allowFullScreen
                                                    ></iframe>
                                                </div>
                                                <div style={{ marginTop: "10px", fontStyle: "italic", color: "#555" }}>
                                                    {t("News12_VID3_DESC")}
                                                </div>
                                            </div>

                                            {/* P7 */}
                                            <h3>{t("News12_P7_MD_H")}</h3>
                                            <p>{t("News12_P7_MD_1")}</p>
                                            <h5>{t("News12_P7_MD_2")}</h5>

                                            {/* Video 4 */}
                                            <div style={{ textAlign: "center", margin: "11px 0" }}>
                                                <div
                                                    style={{
                                                        position: "relative",
                                                        width: "100%",
                                                        paddingBottom: "56.25%",
                                                        height: 0,
                                                        overflow: "hidden",
                                                    }}
                                                >
                                                    <iframe
                                                        style={{
                                                            position: "absolute",
                                                            top: 0,
                                                            left: 0,
                                                            width: "100%",
                                                            height: "100%",
                                                            border: 0,
                                                        }}
                                                        title={t("News12_VID4_DESC")}
                                                        src="https://youtube.com/embed/4p2QlfnuDEc?si=I58fIiZs4ZSZHdzk"
                                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                                        allowFullScreen
                                                    ></iframe>
                                                </div>
                                                <div style={{ marginTop: "10px", fontStyle: "italic", color: "#555" }}>
                                                    {t("News12_VID4_DESC")}
                                                </div>
                                            </div>

                                            {/* P8 */}
                                            <ul>
                                                <li>
                                                    <p>
                                                        <strong>{t("News12_P8_MD_1")}</strong>
                                                        {t("News12_P8_MD_2")}
                                                    </p>
                                                </li>
                                                <li>
                                                    <p>
                                                        <strong>{t("News12_P8_MD_3")}</strong>
                                                        {t("News12_P8_MD_4")}
                                                    </p>
                                                </li>
                                                <li>
                                                    <p>
                                                        <strong>{t("News12_P8_MD_5")}</strong>
                                                        {t("News12_P8_MD_6")}
                                                    </p>
                                                </li>
                                                <li>
                                                    <p>
                                                        <strong>{t("News12_P8_MD_7")}</strong>
                                                        {t("News12_P8_MD_8")}
                                                    </p>
                                                </li>
                                            </ul>
                                            <p>{t("News12_P8_MD_9")}</p>
                                            <p>
                                                <strong>{t("News12_P8_MD_10")}</strong>
                                                {t("News12_P8_MD_11")}
                                            </p>

                                            {/* IMG 3 */}
                                            <div style={{ textAlign: "center", margin: "11px 0" }}>
                                                <img
                                                    src={news12_3}
                                                    alt={t("News12_IMG4_DESC")}
                                                />
                                                <div style={{ marginTop: "10px", fontStyle: "italic", color: "#555" }}>
                                                    {t("News12_IMG4_DESC")}
                                                </div>
                                            </div>

                                            {/* P9 */}
                                            <h3>{t("News12_P9_MD_H")}</h3>
                                            <p>
                                                {t("News12_P9_MD")}
                                            </p>

                                            {/* IMG 4 & IMG 5*/}
                                            <div style={{ textAlign: "center", margin: "11px 0" }}>
                                                <div style={{ display: "flex", justifyContent: "center", gap: 0, flexWrap: "wrap" }}>
                                                    <img
                                                        src={news12_4}
                                                        alt={t("News12_IMG5_DESC")}
                                                        style={{ maxWidth: "50%", height: "auto" }}
                                                    />
                                                    <img
                                                        src={news12_5}
                                                        alt={t("News12_IMG6_DESC")}
                                                        style={{ maxWidth: "50%", height: "auto" }}

                                                    />
                                                </div>

                                                <div style={{ marginTop: "10px", fontStyle: "italic", color: "#555" }}>
                                                    {t("News12_IMG5_DESC")}
                                                </div>
                                                <div style={{ marginTop: "10px", fontStyle: "italic", color: "#555" }}>
                                                    {t("News12_IMG6_DESC")}
                                                </div>
                                            </div>

                                            {/* P10 */}
                                            <p>{t("News12_P10_MD")}</p>

                                            {/* Video 5 */}
                                            <div style={{ textAlign: "center", margin: "11px 0" }}>
                                                <div
                                                    style={{
                                                        position: "relative",
                                                        width: "100%",
                                                        paddingBottom: "56.25%",
                                                        height: 0,
                                                        overflow: "hidden",
                                                    }}
                                                >
                                                    <iframe
                                                        style={{
                                                            position: "absolute",
                                                            top: 0,
                                                            left: 0,
                                                            width: "100%",
                                                            height: "100%",
                                                            border: 0,
                                                        }}
                                                        title={t("News12_VID5_DESC")}
                                                        src="https://youtube.com/embed/uoYw4PAajAg?si=HO9bhveItRKrst_F"
                                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                                        allowFullScreen
                                                    ></iframe>
                                                </div>
                                                <div style={{ marginTop: "10px", fontStyle: "italic", color: "#555" }}>
                                                    {t("News12_VID5_DESC")}
                                                </div>
                                            </div>

                                            {/* P11 */}
                                            <p>
                                                <strong>{t("News12_P11_MD_1")}</strong>
                                                {t("News12_P11_MD_2")}
                                            </p>
                                            <p>
                                                {t("News12_P11_MD_3")}
                                                <strong>{t("News12_P11_MD_4")}</strong>
                                            </p>
                                            <p>
                                                {t("News12_P11_MD_5")}
                                                <strong>{t("News12_P11_MD_6")}</strong><br />
                                                {t("News12_P11_MD_7")}
                                            </p>
                                            <p>
                                                <strong>{t("News12_P11_MD_8")}</strong>
                                            </p>


                                            {/* IMG 6 */}
                                            <div style={{ textAlign: "center", margin: "11px 0" }}>
                                                <img
                                                    src={news12_6}
                                                    alt={t("News12_IMG7_DESC")}
                                                />
                                                <div style={{ marginTop: "10px", fontStyle: "italic", color: "#555" }}>
                                                    {t("News12_IMG7_DESC")}
                                                </div>
                                            </div>

                                            {/* P12 */}
                                            <h3>{t("News12_P12_MD_H")}</h3>
                                            <p>{t("News12_P12_MD_1")}</p>
                                            <p>{t("News12_P12_MD_2")}</p>
                                            <p>
                                                <strong>{t("News12_P12_MD_3")}</strong>
                                            </p>
                                            <p>{t("News12_P12_MD_4")}</p>
                                            <p>{t("News12_P12_MD_5")}</p>

                                            {/* IMG 7 */}
                                            <div style={{ textAlign: "center", margin: "11px 0" }}>
                                                <img
                                                    src={news12_7}
                                                    alt={t("News12_IMG8_DESC")}
                                                />
                                                <div style={{ marginTop: "10px", fontStyle: "italic", color: "#555" }}>
                                                    {t("News12_IMG8_DESC")}
                                                </div>
                                            </div>

                                            {/* P13 */}
                                            <h3>{t("News12_P13_MD_H")}</h3>
                                            <p>{t("News12_P13_MD_1")}</p>
                                            <p>
                                                {t("News12_P13_MD_2")}
                                                <strong><em>{t("News12_P13_MD_3")}</em></strong>
                                                {t("News12_P13_MD_4")}
                                                <strong><em>{t("News12_P13_MD_5")}</em></strong>
                                            </p>
                                            <p>
                                                {t("News12_P13_MD_6")}
                                            </p>

                                            {/* Video 6 */}
                                            <div style={{ textAlign: "center", margin: "11px 0" }}>
                                                <div
                                                    style={{
                                                        position: "relative",
                                                        width: "100%",
                                                        paddingBottom: "56.25%",
                                                        height: 0,
                                                        overflow: "hidden",
                                                    }}
                                                >
                                                    <iframe
                                                        style={{
                                                            position: "absolute",
                                                            top: 0,
                                                            left: 0,
                                                            width: "100%",
                                                            height: "100%",
                                                            border: 0,
                                                        }}
                                                        title={t("News12_VID6_DESC")}
                                                        src="https://youtube.com/embed/GnEqnFGWWRo?si=r1LEz33SMcUI9_xl"
                                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                                        allowFullScreen
                                                    ></iframe>
                                                </div>
                                                <div style={{ marginTop: "10px", fontStyle: "italic", color: "#555" }}>
                                                    {t("News12_VID6_DESC")}
                                                </div>
                                            </div>

                                            {/* P14 */}
                                            <h3>{t("News12_P14_MD_H")}</h3>
                                            <p>{t("News12_P14_MD_1")}</p>
                                            <p>{t("News12_P14_MD_2")}</p>

                                            {/* IMG 8 */}
                                            <div style={{ textAlign: "center", margin: "11px 0" }}>
                                                <img
                                                    src={news12_8}
                                                    alt={t("News12_IMG9_DESC")}
                                                />
                                                <div style={{ marginTop: "10px", fontStyle: "italic", color: "#555" }}>
                                                    {t("News12_IMG9_DESC")}
                                                </div>
                                            </div>

                                            {/* P15 */}
                                            <h3>{t("News12_P15_MD_H")}</h3>
                                            <p>{t("News12_P15_MD")}</p>

                                            {/* Video 7 */}
                                            <div style={{ textAlign: "center", margin: "11px 0" }}>
                                                <div
                                                    style={{
                                                        position: "relative",
                                                        width: "100%",
                                                        paddingBottom: "56.25%",
                                                        height: 0,
                                                        overflow: "hidden",
                                                    }}
                                                >
                                                    <iframe
                                                        style={{
                                                            position: "absolute",
                                                            top: 0,
                                                            left: 0,
                                                            width: "100%",
                                                            height: "100%",
                                                            border: 0,
                                                        }}
                                                        title={t("News12_VID7_DESC")}
                                                        src="https://youtube.com/embed/vXNbTyJf6Xg?si=fpeGHJnLjL73kpL4"
                                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                                        allowFullScreen
                                                    ></iframe>
                                                </div>
                                                <div style={{ marginTop: "10px", fontStyle: "italic", color: "#555" }}>
                                                    {t("News12_VID7_DESC")}
                                                </div>
                                            </div>

                                            {/* P16 */}
                                            <p>
                                                {t("News12_P16_MD_1")}
                                                <strong>{t("News12_P16_MD_2")}</strong>
                                                {t("News12_P16_MD_3")}
                                            </p>
                                            <p>{t("News12_P16_MD_4")}</p>
                                            <p>{t("News12_P16_MD_5")}</p>

                                            {/* P17 */}
                                            <h3>{t("News12_P17_MD_H")}</h3>
                                            <p>{t("News12_P17_MD_1")}</p>
                                            <p>
                                                {t("News12_P17_MD_2")}
                                                <strong>
                                                    <a
                                                        href="https://www.aaio.com.au"
                                                        style={{ textDecoration: 'underline' }}
                                                        target="_blank"
                                                        rel="noopener noreferrer">
                                                        {t("News12_P17_MD_3")}
                                                    </a>
                                                </strong>
                                            </p>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

            </>

        );
    }
}

export default news12 = withTranslation()(news12);
